var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSqlSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66992 10.44V13.45L11.9999 17.35V14.34L4.66992 10.44Z",
    fill: "#3F51B5",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66992 15.09V18.1L11.9999 22V18.99L4.66992 15.09Z",
    fill: "#3F51B5",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 17.35L19.33 13.45V10.44L12 14.34V17.35Z",
    fill: "#7986CB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22L19.33 18.1V15.09L12 18.99V22Z",
    fill: "#7986CB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.33 8.91V5.9L12 2V5.01L19.33 8.91Z",
    fill: "#3F51B5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 2L4.66992 5.9V8.91L11.9999 5.01V2Z",
    fill: "#7986CB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66992 5.87V8.89L11.9999 12.79V9.77L4.66992 5.87Z",
    fill: "#3F51B5",
    fillOpacity: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 12.79L19.33 8.89V5.87L12 9.77V12.79Z",
    fill: "#7986CB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSqlSelected);
export default __webpack_public_path__ + "static/media/sql_selected.fdf931eef608f6844cc766823e75ab5c.svg";
export { ForwardRef as ReactComponent };